<template>
  <div class="container">
    <div class="row statistics">
      <div class="col-md-7 first-div">
        <Statistics />
      </div>
      <div class="col-md-5 second-div">
        <h1>Buyer Account Login</h1>
        <button class="btn btn-sm btn-block btn-outline-primary p-2 mt-5" @click="auth('facebook')">
          <img :src="fbIcon" width="20px" alt /> Sign in with Facebook
        </button>
        <GoogleLogin class="btn btn-sm btn-block btn-outline-primary p-2 mt-2 mb-2" :params="params" :onSuccess="onSuccess" :onFailure="onFailure"><img :src="googleIcon" width="20px" alt /> Sign in with Google</GoogleLogin>
        <div>
          <p class="text-center">or</p>
        </div>
        <EmailLogin :resource="'login'" :is-modal="false"/>
      </div>
    </div>
  </div>
</template>

<script>
import EmailLogin from "@/components/sharable/modals/authentication/EmailLogin";
import fbIcon from "@/assets/images/facebook-icon.png";
import googleIcon from "@/assets/images/google-icon.png";
import { socialAuthUser } from "@/api";
import GoogleLogin from 'vue-google-login';
import { googleLogin } from '@/api/services/login';
import { GOOGLE_CLIENT_ID } from '@/constants';
export default {
  name: 'BuyerLogin',
  data() {
    return {
      fbIcon,
      googleIcon,
      loginRedirect: "",
      params: {
          client_id: GOOGLE_CLIENT_ID
      }
    }
  },
  components: { EmailLogin, GoogleLogin },
  methods: {
    async auth(provider) {
      this.loading = true;
      try {
        const res = await this.$auth.authenticate(provider);
        alert(res);
        const buyer = await socialAuthUser(provider, res);
        if (buyer) {
          this.$emit("authenticate");
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    async onSuccess(googleUser) {
      let { data } = await googleLogin({ token: googleUser.wc.access_token });
      this.$store.dispatch("setUserData", data.data);
      localStorage.setItem("_token", data.data.token.access_token);
      location.reload();
    },
    onFailure(test) {
      console.log('test', test);
    }
  }
};
</script>